import Pristine from "pristinejs";
import axios from 'axios';

window.onload = function () {
  var form = document.getElementById("sign-up");
  if (form) {
    console.log('has form')
    var pristine = new Pristine(form, {
      classTo: "input-wrap",
      errorClass: "error",
      successClass: "success",
      errorTextParent: "input-wrap",
      errorTextTag: "div",
      errorTextClass: "error-message",
    });



    // Add event listener to submit button
    var submitButton = document.getElementById("submit");
    submitButton.addEventListener("click", function (e) {
      //console.log('called 0')
      e.preventDefault(); // Disable default submit
      var valid = pristine.validate(); // Validate the form
      //console.log('called 1')
      if (valid) {

        const formData = new FormData(form);
        const data = {
          email_address: formData.get('email'),
          status: 'subscribed',
          merge_fields: {
            FNAME: formData.get('firstName'),
            LNAME: formData.get('lastName'),
            MMERGE3: formData.get('zip'),
            MMERGE6: 'I am not a healthcare provider',
          },
          //email_address: formData.get('email'),

        };
        console.log(data)

        // TEMP -----------------
        $("#getupdates_thankyou").show();
        $(".form.form-wrapper").hide();
        window.scroll(0, 0);

        // WAITING FOR LAMDA
        // axios.post('https://ustjcdijcar2ywmf6w7uf2jjve0ezosj.lambda-url.us-east-1.on.aws/', data, {
        //   headers: {
        //     'Content-Type': 'application/json'
        //   }
        // }).then(response => {
        //   console.log('Success:', response.data);
        //   $("#getupdates_thankyou").show();
        //   $(".form .note, #sign-up").hide();
        //   window.scroll(0, 0);

        // }).catch(error => {
        //   console.error('Error:', error);
        // });



      } else {
        // Show error messages
        showErrorMessages();
      }
    });

    // Add event listeners to inputs to remove error messages on input
    var inputs = form.querySelectorAll("input, select");
    inputs.forEach(function (input) {
      input.addEventListener("input", function () {
        pristine.validate(input); // Validate the input
        if (input.checkValidity()) {
          input.classList.remove("error");
          var errorDiv = document.getElementById(input.id + "Error");
          if (errorDiv) {
            errorDiv.textContent = "";
            errorDiv.classList.remove("show");
          }
        }
      });
    });
  }

  function showErrorMessages() {
    var fields = ["firstName", "lastName", "email", "zip"];
    fields.forEach(function (field) {
      var input = document.getElementById(field);
      var errorDiv = document.getElementById(field + "Error");
      if (!input.checkValidity()) {
        input.classList.add("error");
        //errorDiv.textContent = 'Please enter your ' + field.replace(/([A-Z])/g, ' $1').toLowerCase();
        errorDiv.classList.add("show");
      } else {
        input.classList.remove("error");
        errorDiv.textContent = "";
        errorDiv.classList.remove("show");
      }
    });


  }

};
